import React from 'react';

const Step6Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-6">
            Richiedi subito il tuo preventivo online con la detrazione fiscale
            fino al 50%.
        </div>
    );
};

export default Step6Infos;
